/**
 * @deprecated use `IrisGridPanelMetadata` instead
 */

export function isLegacyIrisGridPanelMetadata(metadata) {
  if (metadata == null) return false;
  var irisGridPanelMetadata = metadata;
  return typeof irisGridPanelMetadata.table === 'string';
}
export function isIrisGridPanelMetadata(metadata) {
  if (metadata == null) return false;
  var irisGridPanelMetadata = metadata;
  return typeof irisGridPanelMetadata.name === 'string';
}
//# sourceMappingURL=IrisGridPanelTypes.js.map